<template>
  <div class='wt-root' id='root'>
    <div class='wt-uber' id='uber'>
      <div class='wt-head' v-for="(header, index) in headers" :key="index">
        <compare-table-head-item :dashdata="header" />
      </div>
    </div>
    <div class='wt-box' id='wt-box'>
      <div class='wt-cell' v-for="(item, index) in items" :key="index">
        <compare-table-item :dashdata="item"
                            :waves="waves"
                            :history="history"
                            :leadFuThresholds="leadFuThresholds"
                            :lmThresholds="lmThresholds"
                            :thresholds="thresholds" />
      </div>
    </div>
  </div>
</template>

<script>
import CompareTableItem from './CompareTableItem';
import CompareTableLineHeader from './CompareTableLineHeader';
import CompareTableWaveHandling from '@/mixins/bmw/CompareTableWaveHandling.js';

export default {
  mixins: [CompareTableWaveHandling],

  components: {
    'compare-table-item': CompareTableItem,
    'compare-table-head-item': CompareTableLineHeader
  },

  data() {
    return {
      headers: []
    };
  },

  props: {
    dashdata: { type: Array },
    optionsdata: { type: Object },
    selection: { type: Object },
    history: { type: Array },
    thresholds: { type: Array, required: true },
    leadFuThresholds: { type: Array, required: false, default: undefined },
    lmThresholds: { type: Array, required: false, default: undefined }
  },

  computed: {
    waves() {
      let waves = [];
      const src = this.getWaveList();
      for (const item of src) {
        let wave = _.find(waves, function(x) { return x.year == item.Year && x.name == item.quarter });
        if (wave) {
          wave.id = item.Name;
        } else {
          waves.push({ year: item.Year, name: item.quarter, id: item.Name });
        }
      }
      return _.sortBy(waves, ['year', 'name']);
    },

    items() {
      if (!this.dashdata || this.dashdata.length <= 0) {
        return [];
      }
      return this.dashdata;
    },

    firstDatasetWithKPIs() {
      return _.find(this.items, function(x) { return x.KPI && x.KPIGroup; });
    }
  },

  watch: {
    dashdata: {
      handler(newVal, oldVal) {
        this.windowResize();
      },
    },
  },

  created() {
    window.addEventListener("resize", this.windowResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },

  mounted() {
    this.windowResize();
  },

  methods: {
    getWaveList() {
      let waves = [];
      for (const board of this.dashdata) {
        if (board.OverallByWave && board.OverallByWave[0] && board.OverallByWave[0].SurveyWave) {
          for (const wave of board.OverallByWave[0].SurveyWave) {
            this.updateQuarter(wave);
            let item = _.find(waves, function(x) { return x.Year == wave.Year && x.quarter == wave.quarter });
            if (!item) {
              waves.push(wave);
            }
          }
        }
      }
      return waves;
    },

    windowResize(e) {
      if (this.items.length === 0) {
        this.headers = [];
        return;
      }

      const modul = 128;
      let itemBox = document.getElementById('wt-box');
      let itemsPerLine = 5;
      if (itemBox != null && itemBox.lastChild !== null) {
        itemsPerLine = Math.round(itemBox.clientWidth / itemBox.lastChild.clientWidth);
      }
      let lines = Math.floor(this.items.length / itemsPerLine);
      if (this.items.length % itemsPerLine !== 0) {
        lines++;
      }

      if (this.headers.length < lines) {
        let count = lines - this.headers.length;
        for (let i = 0; i < count; i++) {
          this.headers.push(this.firstDatasetWithKPIs);
        }
        return;
      }

      if (this.headers.length > lines) {
        let count = this.headers.length - lines;
        for (let i = 0; i < count; i++) {
          this.headers.pop();
        }
        return;
      }
    }
  }
};

</script>

<style lang="scss" scoped>
  @import "@/../scss/bmw/_variables_compareBoard.scss";

  html, body {
    width:100%;
  }
  .wt-box {
    display: grid;
    width: auto;
    height: auto;
    min-width: $item-width;
    grid-template-columns: repeat(auto-fill,minmax($item-width, 1fr));
    grid-gap: 0.5rem;
  }
  .wt-root {
    margin: 0rem;
    display: grid;
    min-width: $head-width;
    grid-template-columns: $head-width 5fr;
  }
  .wt-uber {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 0.5rem;
    width: $head-width;
    height: auto;
  }
  .wt-head {
    width: $head-width;
    height:  $item-height;
  }
  .wt-cell {
    height: $item-height;
    min-width: $item-width;
  }

</style>

<style lang="scss" scoped>
  @import "@/../scss/bmw/_variables.scss";

  .bborder {
    border-bottom: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .tborder {
    border-top: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  // .n5 {
  //   letter-spacing: -0.05em;
  // }
  // .bu {
  //   font-weight: bold;
  //   text-transform: uppercase;
  // }
</style>
